<template>
    <div style="border-radius:5px; background: #ffffff;float: right;width:min-content; margin: 0 0 5px 5px;position: absolute; z-index: 9999; right: 10px; top: 3px; padding:0 5px; box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)">
        <v-ons-list-item>
            <div class="left">
                <div>
                    <img v-if="userDetails.photo_url" class="list-item__thumbnail" :src="userDetails.photo_url">
                    <span style="background: #e5e5e5; border-radius: 50%; padding: 5px 9px;" v-else>{{firstLetter(userDetails.display_name)}}</span>
                </div>
            </div>
            <div class="center">
                <span class="list-item__title">{{userDetails.display_name}}</span><span class="list-item__subtitle">{{userDetails.email}}</span>
            </div>
        </v-ons-list-item>
        <v-ons-list-item v-if="shouldShowLogout()" tappable @click="logout()" style="border-top: 1px solid #e5e5e5">{{text.logout}}</v-ons-list-item>
    </div>
</template>

<script>
    import {trigetGoogleAnaystEvent} from "../config";
    import usedText from "../util/languageText";
    import { Miniapp } from '../util/Miniapp';
    export default {
        props: {
            userDetails: {
                type: Object,
                defaultValue: () => ({ display_name: '', photo_url: '' })
            }
        },
        name: "UserDrawer",
        data: function () {
            return {
                text: usedText,
                userDetails: this.userDetails
            }
        },
        methods: {
            logout() {
                trigetGoogleAnaystEvent('Logout','logout','logout');
                Miniapp.logout();
            },
            firstLetter(title) {
                return title.charAt(0);
            },
            shouldShowLogout() {
                return !Miniapp.getIsMobileDevice()
            }
        }
    }
</script>

<style scoped>

</style>